import CheckCircle from '@mui/icons-material/CheckCircle'
import Box from '@mui/material/Box'
import { styled } from '@mui/material/styles'
import Typography from '@mui/material/Typography'

export const Root = styled(Box)(() => ({}))

export const Canvas = styled('canvas')(({ theme }) => ({
  width: '100%',
  height: theme.spacing(18.75),
  userSelect: 'none',
}))

export const Frame = styled(Box)(({ theme }) => ({
  backgroundColor: theme.palette.primary[25],
  marginBottom: theme.spacing(0.5),
  padding: theme.spacing(2, 1),
}))

export const Message = styled(Typography)(({ theme }) => ({
  display: 'flex',
  borderTop: `1px solid ${theme.palette.grey[800]}`,
  padding: theme.spacing(0.5, 2, 0, 2),
  color: theme.palette.grey[700],
  width: '100%',
}))

export const SuccessIcon = styled(CheckCircle)(({ theme }) => ({
  width: theme.spacing(2),
  height: theme.spacing(2),
  color: theme.palette.success[600],
  marginRight: theme.spacing(0.5),
}))
